module.exports = __webpack_public_path__ + "img/chat-square-dots-fill.e5a418e4.svg";